import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export function Stamp({ status, className, animate }) {
  const s = (status || "pending").toLowerCase();
  const cls = ["approved", "paid", "hired", "connected", "online", "active", "completed", "assigned"].includes(s) ? "stamp-approved"
    : ["rejected", "disabled", "offline", "resigned", "disconnected"].includes(s) ? "stamp-rejected"
    : ["pending", "submitted", "late", "draft"].includes(s) ? "stamp-pending" : "stamp-neutral";
  return <span data-testid={`stamp-${s}`} className={cn("stamp", cls, animate && "stamp-animate", className)}>{s}</span>;
}

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between rise" data-testid="page-header">
      <div>
        {eyebrow && <div className="eyebrow mb-1.5">{eyebrow}</div>}
        <h1 className="font-serif text-3xl sm:text-4xl tracking-tight font-medium">{title}</h1>
        {description && <p className="mt-1.5 text-sm text-muted-foreground max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, accent = "text-primary", icon: Icon, testId }) {
  return (
    <div className="paper-card paper-card-hover p-5" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div className="eyebrow !text-muted-foreground">{label}</div>
        {Icon && <Icon size={16} className={accent} />}
      </div>
      <div className="mt-3 font-serif text-3xl font-medium ticker">{value}</div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}

export function Avatar({ src, name, size = 36, className }) {
  const [err, setErr] = useState(false);
  const ini = (name || "?").split(" ").map((x) => x[0]).slice(0, 2).join("").toUpperCase();
  return src && !err ? (
    <img src={src} alt={name} onError={() => setErr(true)} style={{ width: size, height: size }} className={cn("rounded-full bg-secondary object-cover ring-1 ring-border", className)} />
  ) : (
    <div style={{ width: size, height: size, fontSize: size / 2.6 }} className={cn("rounded-full bg-secondary text-secondary-foreground grid place-items-center font-serif font-semibold ring-1 ring-border", className)}>{ini}</div>
  );
}

export function EmptyState({ title = "Nothing here yet", hint }) {
  return (
    <div className="py-14 text-center" data-testid="empty-state">
      <div className="mx-auto w-12 h-12 rounded-full border border-dashed border-border grid place-items-center text-muted-foreground font-serif italic">∅</div>
      <div className="mt-3 font-serif text-lg">{title}</div>
      {hint && <div className="text-sm text-muted-foreground">{hint}</div>}
    </div>
  );
}

export function Clock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return <span className="ticker">{now.toLocaleTimeString("en-GB")}</span>;
}

export function Field({ label, children, hint }) {
  return (
    <label className="block space-y-1.5">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      {children}
      {hint && <span className="text-[11px] text-muted-foreground">{hint}</span>}
    </label>
  );
}
